const Layout2 = ({ children, className = "" }) => {
  return (
    <div className={`container ${className}`}>{children}</div>
  );
};

export default Layout2;
